import { colorTokens } from '../../../../shared/src/assets/theme/tokens'
import { ZingTheme } from '../../../../shared/src/assets/theme/types'
import { FONTS } from '../../../../shared/src/constants/fonts'

export const theme: ZingTheme = {
    colors: {
        white: colorTokens.white,
        black: colorTokens.black,
        primary: colorTokens.purple600,
        primaryLight: colorTokens.purple100,
        primaryDark: colorTokens.purple700,
        background: colorTokens.grey100,
        textPrimary: colorTokens.grey700,
        textSecondary: colorTokens.grey500,
        border: colorTokens.grey200,
        error: colorTokens.red,
        grey50:  colorTokens.grey50,
        blue100: colorTokens.blue100,
        blue200: colorTokens.blue200,
        grey400: colorTokens.grey400,
        grey300: colorTokens.grey300,
        grey600: colorTokens.grey600,
        grey800: colorTokens.grey800,
        purple50:        colorTokens.purple50,
        purple100:       colorTokens.purple100,
        purple300:       colorTokens.purple300,
        purple700:       colorTokens.purple700,
        success:         colorTokens.green500,
        successLight:    colorTokens.green100,
        warning:         colorTokens.yellow500,
        warningLight:    colorTokens.yellow100,
        statusPendingBg:     colorTokens.orange50,
        statusPendingText:   colorTokens.orange800,
        statusApprovedBg:    colorTokens.green100,
        statusApprovedText:  colorTokens.green700,
        statusRejectedBg:    colorTokens.red100,
        statusRejectedText:  colorTokens.red900,
        statusCancelledBg:   colorTokens.grey150,
        statusCancelledText: colorTokens.grey550,
        highlight:       colorTokens.orange500,
        highlightLight:  colorTokens.orange100,
        secondaryHighlight: colorTokens.purple50,
        indigoShadow:     colorTokens.indigoShadow,
        shadowSmooth:     colorTokens.shadowSmooth,
        risk:             colorTokens.orange200,
        orangeDark:       colorTokens.orange600,
        sidebarBackground: `linear-gradient(180deg, ${colorTokens.grey800} 0%, ${colorTokens.purple600} 100%)`,
        errorDark:        colorTokens.red700,
        accentOrange:     colorTokens.orange300,
        successAlt:       colorTokens.teal700,
        successBright:    colorTokens.green400,
        datepickerInputBg:      colorTokens.slate50,
        datepickerBorderLight:  colorTokens.slate100,
        datepickerHeaderBorder: colorTokens.slate150,
        datepickerBorder:       colorTokens.slate200,
        datepickerDisabled:     colorTokens.slate300,
        datepickerOutsideMonth: colorTokens.slate400,
        datepickerTextMuted:    colorTokens.slate500,
        datepickerText:         colorTokens.slate900,
        datepickerHoverBg:      colorTokens.sky100,
        datepickerAccent:       colorTokens.sky400,
        overlayTint:       colorTokens.overlayTint,
        overlayTintStrong: colorTokens.overlayTintStrong,
        overlayTintSoft:   colorTokens.overlayTintSoft,
        shadowCardOuter:  colorTokens.shadowCardOuter,
        shadowCardInner:  colorTokens.shadowCardInner,
        shadowElevatedSm: colorTokens.shadowElevatedSm,
        shadowElevatedMd: colorTokens.shadowElevatedMd,
        shadowElevatedLg: colorTokens.shadowElevatedLg,
        shadowPopover:    colorTokens.shadowPopover,
        spacePalette: [
            colorTokens.spaceColor1,
            colorTokens.spaceColor2,
            colorTokens.blue500,
            colorTokens.purple600,
            colorTokens.orange300,
            colorTokens.spaceColor6,
            colorTokens.spaceColor7,
            colorTokens.spaceColor8,
            colorTokens.teal700,
            colorTokens.spaceColor10,
        ],
    },
    fonts: {
        body: FONTS.SUNDRY,
    },
}
